class AccountingEntitySelectionViewController extends MUIViewController
{
    delegate:AccountingEntryDelegate = null;

    static newInstance() : AccountingEntitySelectionViewController {
        let vc = new AccountingEntitySelectionViewController("accounting-entry-selection-view");
        vc.initWithResource("layout/accounting_entries/AccountingEntrySelectionView.html");
        return vc;
    }

    private entitySelectionComboBox:MUIComboBox = null;
    private titleHeaderView:MUIView = null;

    private tableView:UITableView = null;

    private sepaDataSource: SEPADataSource;
    

    viewDidLoad(){
        super.viewDidLoad();

        this.entitySelectionComboBox = MUIOutlet(this, "entity-selection-cb", "MUIComboBox");
        this.entitySelectionComboBox.setOnChangeAction(this, function(this:AccountingEntitySelectionViewController, comboBox:MUIComboBox, value:string){
            this.entitySelectionAction(parseInt(value));      
        });

        this.titleHeaderView = MUIOutlet(this, "title-header-view", "MUIView");
        this.titleHeaderView.hidden = true;

        this.tableView = MUIOutlet(this, "table-view", "UITableView");

        this.sepaDataSource = new SEPADataSource();
        this.sepaDataSource.initWithTableView( this.tableView, this.titleHeaderView, this.delegate );
    }

    private entitySelectionAction(index:number){
        this.titleHeaderView.hidden = true;

        switch (index) {
            case 0: this.sepaDataSource.reloadData(); break;
            case 1: break;
            case 2: break;
        }
    }

}